import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource} from '@api'
import {DEBUG_CHANGE_LOG, useChangeLogFlexLayoutTabStore, useVipLocalStore, VipLocalStore} from '@modules'
import {ChangeLogAccordion} from '@modules/changelog/ChangeLogAccordion'
import * as css from './ChangeLogActionView.css'


export const ChangeLogActionView = observer<{ className?: string }>(function ChangeLogActionView({className}) {
  const rootStore = useChangeLogFlexLayoutTabStore(),
   {keys} = rootStore

  //DEBUG_CHANGE_LOG && console.log({keys})
  return (
      <div className={classNames(css.root, className)}>
        {keys.length === 0 && <div className={css.noData}>No events found.</div>}
        {!_.isEmpty(keys) && <div className={css.accordions}>
          {keys.map((title, index) => <ChangeLogAccordion key={index} title={title} expanded={index === 0} index={index} />)}
        </div>}
      </div>)
})



// WEBPACK FOOTER //
// ./src/modules/changelog/ChangeLogActionView.tsx